import { Box, Stack } from '@mui/material';
import { InformationOutlinedIcon } from '@synergy/theme-next';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import { PoolTooltip, PoolTypography } from '@synergy/components-next';

import { BonusConditionMode } from '../models/bonus-settlement-customer-detail';

interface BonusSettlementDetailBonusConditionTooltipProps {
    title: string;
    mode: BonusConditionMode;
}

export const BonusSettlementCustomerDetailBonusConditionTooltip = (
    props: BonusSettlementDetailBonusConditionTooltipProps
) => {
    const { title, mode } = props;

    return (
        <PaloNextThemeProvider>
            <PoolTooltip
                title={
                    <Stack>
                        <Box>
                            <PoolTypography
                                sx={{ fontWeight: 600 }}
                                variant="body2"
                                translationId={
                                    mode === BonusConditionMode.Amount
                                        ? 'app.bonusSettlements.customerDetail.bonusCondition.mode.amount'
                                        : 'app.bonusSettlements.customerDetail.bonusCondition.mode.percentage'
                                }
                            />
                        </Box>
                        <PoolTypography variant="body2">{title}</PoolTypography>
                    </Stack>
                }
                variant="light"
            >
                <InformationOutlinedIcon
                    sx={{
                        color: theme => theme.palette.grey[700],
                        width: 20,
                        height: 20,
                    }}
                />
            </PoolTooltip>
        </PaloNextThemeProvider>
    );
};
